import { render, staticRenderFns } from "./CardDonate.vue?vue&type=template&id=2715911e&"
import script from "./CardDonate.vue?vue&type=script&lang=js&"
export * from "./CardDonate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports